import * as KeyCloakModule from './keycloak/keycloak';
import {
  KeycloakError,
  KeycloakInitOptions,
  KeycloakInstance,
  KeycloakPkceMethod,
  KeycloakPromise
} from './keycloak/keycloak';
import {AppConfig} from '../../app.config';
import {Injectable} from '@angular/core';
import {Http} from '@angular/http';

export interface KeycloakConfigInterface {
  keyCloakInstance: KeycloakInstance;

  load(http: Http) ;
  initKeycloak(keycloakConfig: KeycloakConfig) ;
}

@Injectable()
export class KeycloakConfig implements KeycloakConfigInterface {

  public keyCloakInstance: KeycloakInstance;

  public static initializeKeycloak(keycloakConfig: KeycloakConfig, http: Http) {
    // console.log(keycloakConfig);
    return (() => keycloakConfig.load(http));
  }

  constructor() {
    // console.log('constructor KeycloakConfig');
  }

  public async load(http: Http) {
    const appConfigIntance = new AppConfig(http);
    const loaded = appConfigIntance.load();
    await loaded;
    const config = appConfigIntance.getConfig();
    const configData: KeyCloakModule.KeycloakConfig = {
      url: config['oidcDomain'] + '/auth', clientId: config['oidcClientID'], realm: config['oidcAuthRealm']
    };
    // console.log(configData);
    this.keyCloakInstance = KeyCloakModule(configData);
    return this.initKeycloak(this);
  }


  // This needs to be called in APP_INITIALIZER so that angular app can use keycloak service
  public async initKeycloak(keycloakConfig: KeycloakConfigInterface) {
    console.log('initKeycloak KeycloakConfig');
    this.keyCloakInstance.onAuthSuccess = function () {
      // TODO: remove debug or change to be able to be turned off.
      console.log('Auth Success');
      let timeSkew = keycloakConfig.keyCloakInstance.timeSkew
      if (timeSkew == null) {
        timeSkew = 0;
      }
      const expiryTime = new Date((keycloakConfig.keyCloakInstance.tokenParsed.exp + timeSkew) * 1000);

      let o = 'Token Expires:\t\t' + expiryTime.toLocaleString() + '\n';
      o += 'Token Expires in:\t' + Math.round(keycloakConfig.keyCloakInstance.tokenParsed.exp + timeSkew - new Date().getTime() / 1000) + ' seconds\n';

      if (keycloakConfig.keyCloakInstance.refreshTokenParsed) {
        o += 'Refresh Token Expires:\t' + new Date((keycloakConfig.keyCloakInstance.refreshTokenParsed.exp + timeSkew) * 1000).toLocaleString() + '\n';
        o += 'Refresh Expires in:\t' + Math.round(keycloakConfig.keyCloakInstance.refreshTokenParsed.exp + timeSkew - new Date().getTime() / 1000) + ' seconds';
      }
      console.log(o);

      // console.log('tokenParsed: ' + JSON.stringify(keycloakConfig.keyCloakInstance.tokenParsed, null, '  '));
      // console.log('token : ' + keycloakConfig.keyCloakInstance.token);
      // console.log('refreshToken : ' + keycloakConfig.keyCloakInstance.refreshToken);
      // console.log('refreshTokenParsed : ' + JSON.stringify(keycloakConfig.keyCloakInstance.refreshTokenParsed, null, '  '));
      // console.log('idToken : ' + keycloakConfig.keyCloakInstance.idToken);
      // console.log('idTokenParsed : ' + JSON.stringify(keycloakConfig.keyCloakInstance.idTokenParsed, null, '  '));
    };

    keycloakConfig.keyCloakInstance.onAuthError = function (errorData) {
      console.log('Auth Error: ' + JSON.stringify(errorData));
    };

    keycloakConfig.keyCloakInstance.onAuthRefreshSuccess = function () {
      console.log('Auth Refresh Success');
    };

    keycloakConfig.keyCloakInstance.onAuthRefreshError = function () {
      console.log('Auth Refresh Error');
    };

    keycloakConfig.keyCloakInstance.onAuthLogout = function () {
      console.log('Auth Logout');
      window.location.replace(window.location.protocol + '//' + window.location.host + '/');
    };

    keycloakConfig.keyCloakInstance.onTokenExpired = function () {
      console.log('Access token expired.');
    };

    keycloakConfig.keyCloakInstance.onActionUpdate = function (status) {
      switch (status) {
        case 'success':
          console.log('Action completed successfully dd');
          break;
        case 'cancelled':
          console.log('Action cancelled by user dd ');
          break;
        case 'error':
          console.log('Action failed dd');
          break;
      }
    };

    const at = localStorage.getItem('access_token')
    const rft = localStorage.getItem('refreshToken')
    const idt = localStorage.getItem('idToken')

    let initObject: KeycloakInitOptions;

    if (at === null) {
      initObject = {
        pkceMethod: 'S256',
        enableLogging: true,
        checkLoginIFrame: false
      };
    } else {
      initObject = {
        pkceMethod: 'S256',
        enableLogging: true,
        checkLoginIFrame: false,
        token: at,
        refreshToken: rft,
        idToken: idt,
        timeSkew: 0
      };
    }

    // console.log('keycloak-config initObject: ' + JSON.stringify(initObject));

    return keycloakConfig.keyCloakInstance.init(initObject);
  }

}



// WEBPACK FOOTER //
// ./app/services/auth/keycloak-config.ts